export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6910.32085a17.jpg";